/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_By_BystepInputs */

const en_pb_by_bystep = /** @type {(inputs: Pb_By_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked by Bystep`)
};

const id_pb_by_bystep = /** @type {(inputs: Pb_By_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperiksa Bystep`)
};

/**
* | output |
* | --- |
* | "Checked by Bystep" |
*
* @param {Pb_By_BystepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_by_bystep = /** @type {((inputs?: Pb_By_BystepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_By_BystepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_by_bystep(inputs)
	return en_pb_by_bystep(inputs)
});